import { IconButton } from "@faire/slate/components/icon-button";
import { ChevronLeft } from "@faire/slate-icons/ChevronLeft";

export interface SignupStepHeaderProps {
  /** 0-100 progress through the signup flow. */
  progressPercent: number;
  onBack?: () => void;
}

/**
 * Lightweight recreation of the signup flow's compact header (logo + thin
 * progress bar). Mirrors packages/core/community compact-nav without importing
 * it directly, since that component pulls in production-only route/asset
 * packages this playground app doesn't resolve.
 */
export const SignupStepHeader: React.FC<SignupStepHeaderProps> = ({
  progressPercent,
  onBack,
}) => {
  const clampedProgress = Math.min(Math.max(0, progressPercent), 100);

  return (
    <>
      <header className="bg-fs-surface-primary grid w-full grid-cols-3 items-center">
        <div className="justify-self-start">
          {onBack ? (
            <IconButton
              aria-label="Back"
              onClick={onBack}
              shape="square"
              variant="tertiary"
              Icon={ChevronLeft}
            />
          ) : null}
        </div>
        <div className="flex flex-col items-center justify-center py-(--slate-spacing-element-large)">
          <span className="type-fs-section-heading text-fs-text-primary tracking-[0.2em]">
            FAIRE
          </span>
        </div>
        <span />
      </header>
      <div
        className="bg-fs-surface-secondary relative h-[4px] w-full"
        role="progressbar"
        aria-label="Signup progress"
        aria-valuenow={clampedProgress}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className="bg-fs-action-surface-default h-full transition-[width] duration-700 ease-in-out"
          style={{ width: `${clampedProgress}%` }}
        />
      </div>
    </>
  );
};
